import ScannerDetail from './ScannerDetail.container';

export default ScannerDetail;
